import { LoginForm } from '@/components/auth/LoginForm'
import { useAuth } from '@/contexts/AuthContext'
import React from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'

const LoginPage: React.FC = () => {
  const { isAuthenticated } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  const from = location.state?.from?.pathname || '/dashboard'

  React.useEffect(() => {
    if (isAuthenticated) {
      navigate(from, { replace: true })
    }
  }, [isAuthenticated, navigate, from])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center flex flex-col items-center">
          <Link to="/" className="inline-block">
            <img src="/logo.svg" alt="ATP Logo" className="h-16 w-auto object-contain" />
          </Link>
          <p className="text-sm text-gray-600">Water Pump E-commerce Platform</p>
        </div>

        <LoginForm />

        <div className="text-center">
          <Link to="/" className="text-sm text-blue-600 underline-offset-4 hover:underline">
            ← Back to website
          </Link>
        </div>
      </div>
    </div>
  )
}

export default LoginPage
